let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dBwdi")).then(() => parcelRequire('74s8I'));